export default "__VITE_ASSET__iPhm_5Zo__"